module.exports = __webpack_public_path__ + "static/media/logo.cd18bdec.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/logo.svg
 ** module id = 209
 ** module chunks = 0
 **/